export default __webpack_public_path__ + "static/media/sketch_example.070cccd5.png";